import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';
import { color } from '@styles/variables/color';

const ROOT_TOP_PADDING = '2.7rem';
const HEADER_HEIGHT = '8.8rem';
const HEADER_MARGIN_BOTTOM = variables.gap.xl;
const RECOMMENDER_MARGIN_TOP = variables.gap.sm;
const SMALL_VIEW_WIDTH = '1530px';

const content = {
  height: `calc(100% - ${variables.topBar.height} - ${ROOT_TOP_PADDING} - ${HEADER_HEIGHT} - ${HEADER_MARGIN_BOTTOM} + ${RECOMMENDER_MARGIN_TOP})`,
  marginRight: variables.gap.sm,
};

export const useStyles = makeStyles(() =>
  createStyles({
    contentTargetingOverlay: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      height: '60rem',
      padding: '2rem 0', //  '2rem 1.6rem',
      position: 'absolute',
      right: 0, // '46.3rem',
      top: '11.4rem',
      width: '60rem',

      [`@media (max-width: 1580px)`]: {
        // right: '28.3rem',
      },
    },

    header: {
      borderBottom: `thin solid ${color.primary.lightGray}`,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 1.6rem 2.4rem 1.6rem',
    },

    closeBtn: {
      height: '2.4rem',
      padding: '0',
      // position: 'absolute',
      // right: 0,
      // top: 0,
      width: '2.4rem',

      '& svg': {
        width: '100%',
        height: '100%',

        '& > path': {
          stroke: variables.colorV2.button.iconAlternate.stroke.default,
        },
      },

      '&:hover': {
        backgroundColor: 'transparent',

        '& svg > path': {
          stroke: variables.colorV2.button.iconAlternate.stroke.hover,
        },
      },
    },
    contentTargetingContainer: {
      // padding: `${ROOT_TOP_PADDING} 0 0`,
      // minHeight: `calc(100vh - ${variables.topBar.height})`,
      display: 'flex',
      gap: '1.6rem',
      justifyContent: 'space-between',
      padding: '2rem 1.6rem',

      // '&[data-ui-type=treatment]': {
      //   [`@media (max-width: ${SMALL_VIEW_WIDTH})`]: {
      //     '& $content': {
      //       width: '20rem',
      //     },

      //     '& $contentLibrary': {
      //       width: 'calc(100% - 20rem)',
      //     },
      //   },
      // },
    },
    content: {
      marginRight: 0,
    },
    contentLibrary: {
      ...content,
      borderRadius: '0 2rem 0 0',
      flex: 1,
      marginRight: 0,
    },
    title: {
      // fontWeight: variables.font.weight.light,
    },
    searchField: {
      '& input': {
        fontSize: variables.font.size.sm,
        fontWeight: variables.font.weight.regular,
      },
      '& input::placeholder': {
        fontSize: variables.font.size.sm,
      },
    },
  }),
);
